import { render, staticRenderFns } from "./GvItem.vue?vue&type=template&id=556e4854&"
import script from "./GvItem.vue?vue&type=script&lang=js&"
export * from "./GvItem.vue?vue&type=script&lang=js&"
import style0 from "./GvItem.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "GvItem.vue"
export default component.exports